
import {  EDIT_USER_INFO_ERROR, EDIT_USER_INFO_POST_ERROR, EDIT_USER_INFO_SUCCESS} from "../actions/types";

export default (state = {  
    error: null,
    edited:{},

    success:false,
}, action) => {
    switch (action.type) {
        case EDIT_USER_INFO_ERROR:
            return {
                ...state,
                error: action.payload,
                loading:false,
                success: false,
                isSnackbarError: true,
                isSwitchSnackbarOn: true,
                ErrorMessage: action.payload.message,
            };
            break; 
            case EDIT_USER_INFO_SUCCESS:
                return {
                    ...state,
                    error: action.payload,
                    loading:false, 
                    success:true,
                    edited:action.payload,
                    isSnackbarError: false,
                    isSwitchSnackbarOn: true,
                    ErrorMessage: 'User Edited Successfully',
                };
                break;
            
        case EDIT_USER_INFO_POST_ERROR:
            return {
                ...state,
                error: state.error,
                loading:false,
                success: false,
                isSnackbarError: true,
                isSwitchSnackbarOn: true,
                ErrorMessage: 'Edit User Error | ' + state.error,
            };
            break;
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/editUserReducer.js